<template>
  <div class="config_main_manage_background">
    <!-- 上部导航栏样式 -->
    <div class="main_topnav config_main_manage_topnav">
      <top-nav class="main_topnav">
        <top-nav-item class="left_item"
                      @click.native="configGoPreviousPageHandle">
          <img class="main_top_img"
               slot="topnavimg"
               src="~assets/img/topnav/zuofanhui.png"
               alt />
          <div slot="topimgtext">返回</div>
        </top-nav-item>
        <top-nav-item>
          <div slot="topimgtext">选择一个按钮图标</div>
        </top-nav-item>
        <top-nav-item class="right_item"
                      @click.native="configReturnContronBtnHandle">
          <img class="main_top_img"
               slot="topnavimg"
               src="~assets/img/topnav/shebei_home.png"
               alt />
        </top-nav-item>
      </top-nav>
    </div>

    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
        <div class="select_icon_page_wraper">
          <div class="select_one_icon_wraper"
               v-for="(value, index) in serveIconData"
               :key="index"
               :class="
              String(value.iconId) == OneInfo.iconId
                ? 'select_one_icon_wraper_active'
                : ''
            "
               @click="selectIconBtnHandle(value)">
            <img :src="value.iconUrl"
                 alt />
          </div>
        </div>

        <div class="public_config_que_ren_btn"
             @click="saveReturnBtnHandle">
          保存并返回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'

export default {
  data () {
    return {
      serveIconData: [], ///服务器请求到的icon数据
      // 代号 20231207-1  组功能实现
      OneInfo: {
        /// ///一个虚拟的部分场景信息，
        iconId: '',
        iconUrl: ''
      }
    }
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    configGoPreviousPageHandle () {
      this.$router.go(-1)
    },
    selectIconBtnHandle (value) {
      console.log('选择icon的按钮')
      /// 点击了区域按钮 显示勾选img
      /// 点击了区域按钮 显示勾选img  这样操作其实是直接操作的仓库，因为现在OneInfo它已经指向了仓库地址
      ///这样做其实是不好的，因为没有通过VUEX的提交功能区修改，这样后期调试是没办法通过工具检测数据修改来源的。
      // console.log(typeof(value.iconId))
      this.OneInfo.iconId = String(value.iconId)
      this.OneInfo.iconUrl = value.iconUrl

      // console.log(typeof(this.OneInfo.iconId))
    },
    saveReturnBtnHandle () {
      ///保存并返回按钮点击了
      if (this.OneInfo.iconId === '') {
        this.$toast('请先点击选择一个图标！')
        return
      }
      //提交到仓库
      ////提交页面用户设置的部分场景信息的地址 到仓库（注意提交的是地址，但实际不是地址，最后做了一下深层克隆）
      if (this.$route.query.type === 1) {
        ///1代表是场景页面进来 选择icon的  出去的时候需要判断一下上传地址
        this.$store.dispatch('asyUpdataOneSceneinfo', this.OneInfo)
      } else if (this.$route.query.type === 2) {
        ///2代表是设备页面进来 选择icon的  进来的时候需要判断拉取的地址
        this.$store.dispatch(
          'asyUpdataServeOneObjectIconinfo',
          this.OneInfo
        ) ////异步提交ICON数据
      }
      else if (this.$route.query.type === 3) {
        // 代号 20231207-1  组功能实现
        ///3代表是组页面进来 选择icon的  出去的时候需要判断一下上传地址
        this.$store.dispatch('asyUpdataOneGroupinfo', this.OneInfo)
      }
      this.$router.go(-1)
    },
    configReturnContronBtnHandle () {
      ////配置页面的主页返回按钮被点击了
      this.$router.replace(this.$store.state.publicinfo.configReturnPath)
    }
  },
  created () {
    console.log('created阶段')
    // 代号 20231207-1  组功能实现
    let iconType = this.$route.query.type
    if (iconType == 3) {
      //当为组时使用设备的icon
      iconType = 2; //图片的类型  0:产品 1:场景 2:设备
    }

    // 请求icon信息接口，获取数据
    this.$request({
      method: 'post',
      url: '/config/findAppIconList',
      data: {
        // token: this.$store.state.token
        iconType: iconType // 代号 20231207-1  组功能实现
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.serveIconData = res.data.data ////拿到服务器返回的数据结果
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error)
      })

    if (this.$route.query.type === 1) {
      ///1代表是场景页面进来 选择icon的  进来的时候需要判断拉取的地址
      this.OneInfo.iconId = this.$store.state.configinfo.OneSceneinfo.iconId
      this.OneInfo.iconUrl = this.$store.state.configinfo.OneSceneinfo.iconUrl
    } else if (this.$route.query.type === 2) {
      ///2代表是设备页面进来 选择icon的  进来的时候需要判断拉取的地址
      this.OneInfo.iconId = this.$store.state.configinfo.ServeOneObjectinfo.iconId
      this.OneInfo.iconUrl = this.$store.state.configinfo.ServeOneObjectinfo.iconUrl
    }
    else if (this.$route.query.type === 3) {
      ///2代表是组页面进来 选择icon的  进来的时候需要判断拉取的地址
      // 代号 20231207-1  组功能实现
      this.OneInfo.iconId = this.$store.state.configinfo.OneGroupinfo.iconId
      this.OneInfo.iconUrl = this.$store.state.configinfo.OneGroupinfo.iconUrl
    }
  }
}
</script>

<style>
.select_icon_page_wraper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: space-around;
  align-items: center;

  margin: 20px 60px;
}
.select_one_icon_wraper {
  height: 80px;
  width: 80px;

  border-radius: 4px;
  border: 1px solid #f2f2f2;
  margin: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
}
.select_one_icon_wraper:hover {
  border: 1px solid #40a8fb;
}
.select_one_icon_wraper_active {
  border: 1px solid #40a8fb;
}
.select_one_icon_wraper img {
  width: 34px;
  height: 34px;
}
</style>
